// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import 'cleave.js/dist/addons/cleave-phone.us'
import Cleave from 'cleave.js/react'

import { TextboxProps } from './Textbox.types'

import InputWrapper from '../InputWrapper/InputWrapper'
import useInput from '../useInput'
import Icon from '../../Icon/Icon'
import Button from '../../Button/Button'

const useFormat = (value, format) => {
    const [formattedValue, setFormattedValue] = useState(value)

    const handleFormatting = () => {}

    useEffect(() => {
        if (format) {
            handleFormatting()
        }
    }, [value])

    return {
        value: formattedValue,
    }
}

const Textbox: React.FC<TextboxProps> = (props) => {
    const { placeholder, placeholderIcon, placeholderIconProps, name, type, autoFocus, maxLength } = props
    const context = useInput(props, 'string')
    const { onBlur, onFocus, onChange, value, isDisabled } = context
    const internalRef = useRef(null)
    const [cleaveRef, setCleaveRef] = useState(null)
    const [internalType, setInteralType] = useState(type)
    const handleChange = (e) => {
        let val = e.target.value
        if (isDisabled) {
            return
        }

        if (maxLength !== undefined) {
            val = val.substr(0, maxLength)
        }

        if (val !== value) {
            onChange(val)
        }
    }

    useEffect(() => {}, [])

    const togglePasswordView = () => {
        if (type === 'password') {
            setInteralType((prev) => {
                return prev === 'password' ? 'text' : 'password'
            })
        }
    }

    const _placeholder = (
        <span
            className={'r-input-placeholder-container'}
            onClick={() => {
                internalRef?.current?.focus()
            }}
        >
            {placeholderIcon ? <Icon type={placeholderIcon} {...placeholderIconProps} /> : null}
            {placeholder}
        </span>
    )

    if (props.format) {
        const cleaveOptions = props.format

        // @ts-ignore
        return (
            <InputWrapper {...context} inputType={'textbox'}>
                {_placeholder}
                <Cleave
                    onInit={(cleave) => {
                        //@ts-ignore
                        internalRef.current = cleave.element
                    }}
                    // ref={internalRef}
                    id={'input-' + name}
                    autoFocus={autoFocus}
                    options={cleaveOptions}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    disabled={isDisabled}
                    data-testid='Textbox'
                    className={'r-textbox r-input-base'}
                    value={value}
                    onChange={handleChange}
                />
            </InputWrapper>
        )
    }

    return (
        <InputWrapper {...context} inputType={'textbox'}>
            {_placeholder}
            <input
                ref={internalRef}
                id={'input-' + name}
                autoFocus={autoFocus}
                type={internalType}
                onFocus={onFocus}
                onBlur={onBlur}
                disabled={isDisabled}
                data-testid='Textbox'
                className={'r-textbox r-input-base'}
                value={value}
                onChange={handleChange}
            />
            {type === 'password' ? (
                <div className={'r-input-eye-container'}>
                    <Button
                        onClick={togglePasswordView}
                        icon={internalType === 'password' ? 'eye' : 'eye-slash'}
                        size={'xs'}
                        isDiscreet
                    />
                </div>
            ) : null}
        </InputWrapper>
    )
}

export default Textbox
